import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from '@env/environment';
import { UploadType } from '@enums/upload-type';
import { IMyProfile } from '@interfaces/my-profile';
import { ISiteSearch } from '@interfaces/site-search';
import { Store } from '@ngxs/store';
import { AuthenticationService } from '@services/authentication.service';
import { GetMyProfile } from '@store/profiles.action';
import { ProfilesState } from '@store/profiles.state';
import { Observable, Subscription, filter } from 'rxjs';
import { NgClass, AsyncPipe } from '@angular/common';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { ReplaceHostDirective } from '../../directives/replace-host/replace-host.directive';
import { ImageDirective } from '../../directives/image/image.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [NgClass, RouterLink, RouterLinkActive, LanguageSelectorComponent, ReplaceHostDirective, ImageDirective, AsyncPipe, TranslatePipe]
})
export class HeaderComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private store = inject(Store);
  private router = inject(Router);
  private formBuilder = inject(UntypedFormBuilder);
  private authenticationService = inject(AuthenticationService);

  public myProfile$: Observable<IMyProfile | undefined> = this.store.select(ProfilesState.getMyProfile);
  public mainSearchForm = new UntypedFormGroup({});
  public siteName = environment.companyName;
  public inverse = false;
  public isAuthenticated$ = this.authenticationService.isAuthorized();
  public uploadTypeEnum = UploadType;

  constructor() {
    this.mainSearchForm = this.formBuilder.group({
      searchPhrase: ['']
    });

    this.subscriptions.push(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          this.setInverse(this.router.url);
        })
    );
  }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.authenticationService.isAuthorized().subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          this.store.dispatch(new GetMyProfile());
        }
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public onSubmit(model: ISiteSearch): void {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/search', model.searchPhrase]);
    });
  }

  public login(): void {
    this.router.navigate(['/login']);
  }

  public logOff(): void {
    this.authenticationService.logout();
  }

  private setInverse(route: string): void {
    if (route.indexOf('summit2024') >= 0 || route.indexOf('summit2025') >= 0 || route.indexOf('summit2026') >= 0) {
      this.inverse = true;
    } else {
      this.inverse = false;
    }
  }
}
